import { LogLevel, errorHandlingSwrOptions, getLogger } from '@ori/checkout-utils';
import { useGetCustomerEndConsumers } from '@ori/global-api-client-react';

import { APP_NAME } from '../constants';
import { useConfiguration } from '../contexts/configurationContext';

const logDebug = getLogger(APP_NAME, LogLevel.Debug);

export function useEndConsumers() {
  const { customerId, tenant } = useConfiguration();
  const headers = { 'x-tenant-context': tenant };
  const swrOptions = {
    ...errorHandlingSwrOptions,
    onSuccess: () => {
      logDebug('useEndConsumers() hook finished successfully');
    },
  };

  const { data, error, isValidating: isLoading } = useGetCustomerEndConsumers(customerId, headers, { swr: swrOptions });

  return {
    data,
    error,
    isLoading,
  };
}
